<template>
  <div class="container">
    <b-row class="justify-content-center sm-4 ">
      <b-col sm="12"
             class="cardSize"
             tag="b-card">
        <b-alert :show="errorMessage.length > 0"
                 variant="danger">
          {{ errorMessage }}
        </b-alert>

        <b-row class="cardNewLogin">
          <b-col sm="12"
                 md="8"
                 lg="5"
                 class="alignItens">
            <img alt="Logo Sofia"
                 class="img-fluid logoSofia"
                 src="../assets/icons/logo-sofia.svg">
            <label class="mb-0 mt-4">Bem-vindo ao <b>Sof</b>tware <b>I</b>nteligente <b>A</b>rpen!</label>
            <label>Faça seu login para continuar</label>
          </b-col>

          <b-col class="verticalLine" />

          <b-row class="col">
            <b-col sm="12"
                   md="8"
                   lg="11"
                   class="alignItens text-left">
              <label>
                Buscando o implemento na segurança da plataforma, a partir de <i>16/02/2023</i>,
                o acesso ao SOFIA REI será realizado mediante a utilização da <b>Identificação do Registro Civil do Brasil - IdRC</b>. <br>
                O uso de certificado digital ICP-Brasil será permitido enquanto estiver em curso o processo de migração.
                <br>
                <a href="https://www.home.idrc.registrocivil.org.br/">Conheça a IdRC.</a>
              </label>
            </b-col>

            <b-col sm="5"
                   class="certBorder alignItens">
              <b-button
                :disabled="isSubmitting"
                class="mb-2 btnLogin"
                @click="onSubmitIDRC">
                Entrar com a IdRC
              </b-button>
              <b-row>
                <img :src="logoIDRC"
                     class="smartCardIDRC"
                     @click="onSubmitIDRC">
              </b-row>
            </b-col>

            <b-col sm="5"
                   class="certBorder alignItens">
              <b-button
                :disabled="isSubmitting"
                class="mb-2 btnLogin"
                @click="onClickCertificado">
                Entrar com certificado digital
              </b-button>

              <b-row>
                <img :src="smartCard"
                     class="smartCard">
              </b-row>
            </b-col>
          </b-row>
        </b-row>

        <b-row class="justify-content-end">
          <b-button class="Login_btnSuporte"
                    variant="default"
                    @click="openChat()">
            <icon-svg icon="contactSupport"
                      class="icon--sm Login_btnSuporte--icon" /> Precisa de ajuda?
          </b-button>
        </b-row>
      </b-col>
    </b-row>

    <b-modal ref="modalCertificados"
             hide-footer
             title="Selecione um certificado"
             size="lg">
      <grid-certificados v-if="certificados && certificados.length > 0"
                         :certificados="certificados"
                         @onSelectCertificado="onSelectCertificado" />
    </b-modal>
  </div>
</template>

<script>

  /* services */
  //import { authenticate, authenticateChallenge } from '@/services/sofia-auth/auth'
  import AuthService from "@/services/Auth/AuthService"
  import BryService from '@/services/Assinaturas/BryService'

  /* components */
  import GridCertificados from '../components/GridCertificados'

  /* icons */
  import smartCard from "@/assets/icons/smart-card-arpen.svg"
  import account from "@/assets/icons/account.svg?sprite"
  import certificate from "@/assets/icons/certificate.svg?sprite"
  import eye from "@/assets/icons/eye.svg?sprite"
  import eyeGray from "@/assets/icons/eye-gray.svg?sprite"
  import logoIDRC from "@/assets/icons/logo-idrc-com-mao-com-texto.svg"

  /* others */
  import { mapGetters } from 'vuex'

  export default {
    components: {
      GridCertificados,
    },
    data () {
      return {
        newVersion: null,
        smartCard,
        account,
        certificate,
        eye,
        eyeGray,
        logoIDRC,
        certificados: null,
        certificadoSelecionado: null,
        formData: {
          login: '',
          senha: ''
        },
        error: false,
        isSubmitting: false,
        errorMessage: ''
      }
    },
    computed: {
      ...mapGetters({
        logged: 'auth/confirmLogin',
        userToken: 'auth/getUserToken',
        cartorioId: 'auth/getCartorioId'
      })
    },
    beforeMount () {
      // verifico se enviou o token no get
      if (!this.userToken && this.$route.query.token) {
        this.onLoginSuccess({
          token: this.$route.query.token
        })
      }

      if (this.userToken) {
        this.onLoginSuccess({
          token: this.userToken
        })
      } else {
        this.$store.dispatch('auth/logout').then(result => result)
      }

      this.$store.dispatch('lote/updateLoteRegistrosSelecionados', [])
    },
    methods: {
      onSubmitIDRC () {
        try {
          loader({ text: 'Autenticando usuário...', active: true })

          return this.$store.dispatch('auth/loginIDRC')
        } catch (e) {
          this.onLoginError('Erro', 'Usuario sem permissão de acesso.')
        } finally {
          loader({ text: '', active: false })
        }
      },
      onSubmit () {
        this.$validator.validate().then(resp => {
          if (resp) {
            loader({ text: 'Autenticando usuário...', active: true })

            AuthService.authenticate(this.formData)
              .then(this.onLoginSuccess)
              .catch(() => {
                this.onLoginError('Erro', 'Usuário ou senha incorretos')
              }).finally(() => {
                loader({ text: '', active: false })
              })
          }
        })
      },
      onLoginSuccess ({ token }) {
        return this.$store.dispatch('auth/login', token).then(() => {
          this.$router.push({ name: 'acessar_cartorio' })
        })
      },
      onLoginError (title, text) {
        loader({ text: '', active: false })

        objSwal.error.title = title
        objSwal.error.text = text
        return Swal.fire(objSwal.error)
      },
      async onClickCertificado () {
        loader({ text: 'Validando extensão...', active: true })

        if (!BryService.isExtensionInstalled()) {
          loader({ text: '', active: false })

          objSwal.info.title = 'Extensão não instalada'
          objSwal.info.text = 'A extensão para assinatura digital não está instalada no seu navegador. Deseja instalar agora?'
          objSwal.info.confirmButtonText = 'Instalar'
          objSwal.info.showCancelButton = true
          objSwal.info.cancelButtonText = 'Não'

          return Swal.fire(objSwal.info).then(({ value }) => {
            if (value) {
              try {
                BryService.getExtension()
              } catch (e) {
                this.onLoginError('Erro', e.message)
              }
            }
          })
        }

        loader({ text: 'Obtendo certificados...', active: true })

        // Retornamos apenas certificados do tipo 'A3'
        const certificados = await BryService.getCertificates()

        this.certificados = certificados.filter(certificate => {
          return certificate.certificateType === 'A3'
        })

        loader({ text: '', active: false })

        if (this.certificados.length === 0) {
          return this.onLoginError('Erro', 'Não foi possível selecionar o certificado. Nenhum certificado foi encontrado')
        }

        if (this.certificados.length > 1) {
          this.$refs.modalCertificados.show()
        } else {
          this.certificadoSelecionado = this.certificados[0]

          // Anulando certificados obtidos
          this.certificados = null

          this.autenticarCertificado()
        }
      },
      onSelectCertificado (certificado) {
        this.certificadoSelecionado = certificado

        // Fechando modal
        this.$refs.modalCertificados.hide()

        // Anulando certificados obtidos
        this.certificados = null

        // Autenticando o usuário
        this.autenticarCertificado()
      },
      async autenticarCertificado () {
        loader({ text: 'Autenticando via certificado digital...', active: true })

        try {
          this.desafioGerado = await BryService.makeChallenge()
        } catch (e) {
          loader({ text: '', active: false })
          return this.onLoginError('Erro', 'Não foi possível gerar o token de autenticação')
        }

        BryService.signBase64Content(
          this.certificadoSelecionado.certId,
          BryService.prepareContentForSignature(this.desafioGerado.challenge)
        )
          .then(async (signature) => {
            this.desafioCifrado = signature.assinaturas[0].hashes[0]

            loader({ text: 'Validando certificado digital...', active: true })

            AuthService.authenticateChallenge(
              this.desafioGerado.challenge,
              this.desafioCifrado,
              this.certificadoSelecionado.certificateData
            )
              .then(this.onLoginSuccess)
              .catch((error) => {
                const message = error.response.data.message || 'Não foi possível validar o certificado.'

                this.onLoginError('Erro', message)

                console.error(error.response.data)
              })
              .finally(() => {
                loader({ text: '', active: false })
              })
          }, ({ description, code }) => {
            this.onLoginError(`Erro ${code}`, description)
          })
          .finally(() => {
            loader({ text: '', active: false })
          })
      },
      returnPass (obj) {
        var obj = document.getElementById('id_senha')
        obj.type = "password"
      },
      showPass (obj) {
        var obj = document.getElementById('id_senha')
        obj.type = "text"
      },
      openChat () {
        this.$router.push({ name: 'Atendimento' })
      },
    }
  }
</script>

<style lang="scss">
  .Login {
    &_alert {
      color: #000;
      background-color: #93acbc;
      border-color: #4b89bc;
      border: 2px solid;
      border-radius: 0;
      font-family: 'Roboto';
      font-size: 16px;
    }

    &-border ul.nav > li.nav-item > a {
      border: 1px solid #696969;
      border-bottom: 0;
      border-top-left-radius:5px;
      border-top-right-radius:5px;
      color: black;
      font-size: pxToRem(15);
    }
    &-border ul.nav > li.nav-item > a:hover {
      border: 1px solid #696969;
      border-bottom: 0;
      border-top-left-radius:5px;
      border-top-right-radius:5px;
    }

    &_btnSuporte {
      padding: 5px;
      color: #074f7f;
      border: 2px solid #074f7f;

      &--icon {
        fill: #074f7f;
      }
    }
  }
  .verticalLine {
    border-left: solid 1px black;
    flex-grow: 0;
    padding: 0px;
  }
  .card {
   padding: 0;
   border-radius: 0;
   margin-bottom: 10px;
  }
  .cardNewLogin {
    height: 95%;
  }
  .alignItens {
    align-self: center;
  }
  .logoSofia {
    max-width: 388px;
  }
  .smartCard {
     width: 190px ;
     height: auto;
     margin: auto;
     position: relative;
     top: 20px;
  }
  .smartCardIDRC {
    width: 250px;
    height: auto;
    margin: auto;
    position: relative;
    top: 25px;
  }
    .certBorder{
      border: solid 1px #0770B4;
      border-top-left-radius: 0.25rem;
      border-top-right-radius: 0.25rem;
      text-align: center;
      margin: auto;
      height: 50%;
      padding: 0;
    }
    .cardSize{
      width: 1200px ;
      height: 500px;
      max-width: 1200px ;
      max-height: 500px;
    }

     .eye {
         cursor: pointer;
         left: 200px;
         position: relative;
         top:-32px;
     }
  .certLogin{
    position:relative;
    top: -55px;
    left:295px;
    padding: 0.375rem 0.82rem;
  }
  .btnLogin{
    padding: 0.375rem 1rem;
    width: inherit;
  }
  .card-body{
    padding-left: 2rem;
  }
  .cardLogin{
    position: relative;
    left: 15px;
  }
  .loginBorder{
    padding-right:1.75rem ;
  }
</style>
